import { render, staticRenderFns } from "./CancelFees.vue?vue&type=template&id=125f89d8&scoped=true"
import script from "./CancelFees.vue?vue&type=script&lang=js"
export * from "./CancelFees.vue?vue&type=script&lang=js"
import style0 from "./CancelFees.vue?vue&type=style&index=0&id=125f89d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f89d8",
  null
  
)

export default component.exports